/**
 * check if it is a json 
 * @param {string} str 
 * @returns 
 */
const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export { isJson };